/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfBuild } from '../models';
// @ts-ignore
import type { BfClientType } from '../models';
// @ts-ignore
import type { BfInstance } from '../models';
// @ts-ignore
import type { BfPreferredSignIn } from '../models';
// @ts-ignore
import type { BfProvidersRequest } from '../models';
// @ts-ignore
import type { BfSignupRequest } from '../models';
/**
 * LoginApi - axios parameter creator
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Login with Apple
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleLogin: async (instance: BfInstance, client: BfClientType, build: BfBuild, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('appleLogin', 'instance', instance)
            // verify required parameter 'client' is not null or undefined
            assertParamExists('appleLogin', 'client', client)
            // verify required parameter 'build' is not null or undefined
            assertParamExists('appleLogin', 'build', build)
            const localVarPath = `/v1/login/apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (instance !== undefined) {
                localVarQueryParameter['instance'] = instance;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (build !== undefined) {
                localVarQueryParameter['build'] = build;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This will send a login token to the email address.
         * @summary Send OTC to email
         * @param {BfProvidersRequest} bfProvidersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOtc: async (bfProvidersRequest: BfProvidersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfProvidersRequest' is not null or undefined
            assertParamExists('emailOtc', 'bfProvidersRequest', bfProvidersRequest)
            const localVarPath = `/v1/login/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfProvidersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with Facebook
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin: async (instance: BfInstance, client: BfClientType, build: BfBuild, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('facebookLogin', 'instance', instance)
            // verify required parameter 'client' is not null or undefined
            assertParamExists('facebookLogin', 'client', client)
            // verify required parameter 'build' is not null or undefined
            assertParamExists('facebookLogin', 'build', build)
            const localVarPath = `/v1/login/facebook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (instance !== undefined) {
                localVarQueryParameter['instance'] = instance;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (build !== undefined) {
                localVarQueryParameter['build'] = build;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with Google
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin: async (instance: BfInstance, client: BfClientType, build: BfBuild, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('googleLogin', 'instance', instance)
            // verify required parameter 'client' is not null or undefined
            assertParamExists('googleLogin', 'client', client)
            // verify required parameter 'build' is not null or undefined
            assertParamExists('googleLogin', 'build', build)
            const localVarPath = `/v1/login/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (instance !== undefined) {
                localVarQueryParameter['instance'] = instance;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (build !== undefined) {
                localVarQueryParameter['build'] = build;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with Microsoft
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoftLogin: async (instance: BfInstance, client: BfClientType, build: BfBuild, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('microsoftLogin', 'instance', instance)
            // verify required parameter 'client' is not null or undefined
            assertParamExists('microsoftLogin', 'client', client)
            // verify required parameter 'build' is not null or undefined
            assertParamExists('microsoftLogin', 'build', build)
            const localVarPath = `/v1/login/microsoft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (instance !== undefined) {
                localVarQueryParameter['instance'] = instance;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (build !== undefined) {
                localVarQueryParameter['build'] = build;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This will return preferred providers for the email address.
         * @summary Login providers for user
         * @param {BfProvidersRequest} bfProvidersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersForUser: async (bfProvidersRequest: BfProvidersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfProvidersRequest' is not null or undefined
            assertParamExists('providersForUser', 'bfProvidersRequest', bfProvidersRequest)
            const localVarPath = `/v1/login/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfProvidersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign up with email address.
         * @summary Sign up request
         * @param {BfSignupRequest} bfSignupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup: async (bfSignupRequest: BfSignupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfSignupRequest' is not null or undefined
            assertParamExists('signup', 'bfSignupRequest', bfSignupRequest)
            const localVarPath = `/v1/login/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfSignupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 */
export const LoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Login with Apple
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleLogin(instance, client, build, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginApi.appleLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This will send a login token to the email address.
         * @summary Send OTC to email
         * @param {BfProvidersRequest} bfProvidersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailOtc(bfProvidersRequest: BfProvidersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailOtc(bfProvidersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginApi.emailOtc']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with Facebook
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facebookLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facebookLogin(instance, client, build, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginApi.facebookLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with Google
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleLogin(instance, client, build, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginApi.googleLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with Microsoft
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async microsoftLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.microsoftLogin(instance, client, build, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginApi.microsoftLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This will return preferred providers for the email address.
         * @summary Login providers for user
         * @param {BfProvidersRequest} bfProvidersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providersForUser(bfProvidersRequest: BfProvidersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfPreferredSignIn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providersForUser(bfProvidersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginApi.providersForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign up with email address.
         * @summary Sign up request
         * @param {BfSignupRequest} bfSignupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signup(bfSignupRequest: BfSignupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signup(bfSignupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginApi.signup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoginApi - factory interface
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginApiFp(configuration)
    return {
        /**
         * 
         * @summary Login with Apple
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appleLogin(instance, client, build, options).then((request) => request(axios, basePath));
        },
        /**
         * This will send a login token to the email address.
         * @summary Send OTC to email
         * @param {BfProvidersRequest} bfProvidersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOtc(bfProvidersRequest: BfProvidersRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.emailOtc(bfProvidersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with Facebook
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facebookLogin(instance, client, build, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with Google
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.googleLogin(instance, client, build, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with Microsoft
         * @param {BfInstance} instance Instance type
         * @param {BfClientType} client Client being used
         * @param {BfBuild} build Build being used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoftLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.microsoftLogin(instance, client, build, options).then((request) => request(axios, basePath));
        },
        /**
         * This will return preferred providers for the email address.
         * @summary Login providers for user
         * @param {BfProvidersRequest} bfProvidersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersForUser(bfProvidersRequest: BfProvidersRequest, options?: RawAxiosRequestConfig): AxiosPromise<BfPreferredSignIn> {
            return localVarFp.providersForUser(bfProvidersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign up with email address.
         * @summary Sign up request
         * @param {BfSignupRequest} bfSignupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(bfSignupRequest: BfSignupRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.signup(bfSignupRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginApi - object-oriented interface
 */
export class LoginApi extends BaseAPI {
    /**
     * 
     * @summary Login with Apple
     * @param {BfInstance} instance Instance type
     * @param {BfClientType} client Client being used
     * @param {BfBuild} build Build being used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public appleLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig) {
        return LoginApiFp(this.configuration).appleLogin(instance, client, build, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This will send a login token to the email address.
     * @summary Send OTC to email
     * @param {BfProvidersRequest} bfProvidersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public emailOtc(bfProvidersRequest: BfProvidersRequest, options?: RawAxiosRequestConfig) {
        return LoginApiFp(this.configuration).emailOtc(bfProvidersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with Facebook
     * @param {BfInstance} instance Instance type
     * @param {BfClientType} client Client being used
     * @param {BfBuild} build Build being used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facebookLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig) {
        return LoginApiFp(this.configuration).facebookLogin(instance, client, build, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with Google
     * @param {BfInstance} instance Instance type
     * @param {BfClientType} client Client being used
     * @param {BfBuild} build Build being used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public googleLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig) {
        return LoginApiFp(this.configuration).googleLogin(instance, client, build, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with Microsoft
     * @param {BfInstance} instance Instance type
     * @param {BfClientType} client Client being used
     * @param {BfBuild} build Build being used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public microsoftLogin(instance: BfInstance, client: BfClientType, build: BfBuild, options?: RawAxiosRequestConfig) {
        return LoginApiFp(this.configuration).microsoftLogin(instance, client, build, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This will return preferred providers for the email address.
     * @summary Login providers for user
     * @param {BfProvidersRequest} bfProvidersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public providersForUser(bfProvidersRequest: BfProvidersRequest, options?: RawAxiosRequestConfig) {
        return LoginApiFp(this.configuration).providersForUser(bfProvidersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign up with email address.
     * @summary Sign up request
     * @param {BfSignupRequest} bfSignupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public signup(bfSignupRequest: BfSignupRequest, options?: RawAxiosRequestConfig) {
        return LoginApiFp(this.configuration).signup(bfSignupRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

